import ResourceList from "../resources/ResourceList";
import { resourcesConfig } from "../resources/resourcesConfig";

const Turnos = () => {
    return <ResourceList {...resourcesConfig.turnos} />;
};

export default Turnos;
